<template>
  <div>
    <CRow>
      <CCol col="12">
        <CCard>
          <CCardHeader>
            <strong>{{$t('settings')}}</strong>
          </CCardHeader>
          <CCardBody>
            <CTabs>
              <CTab :title="$t('site_settings')">
                <CRow>
                  <CCol col="6" v-for="lang in languages">
                    <CInput
                        v-model="site_config.titles.filter(x=>x.lng==lang.id)[0].title"

                        :label="lang.name"
                        :placeholder="$t('site_title')"
                        vertical
                    />
                    <CInput
                        v-model="site_config.titles.filter(x=>x.lng==lang.id)[0].description"

                        :label="lang.description"
                        :placeholder="$t('site_summary')"
                        vertical
                    />
                    <CSelect
                        v-model="site_config.titles.filter(x=>x.lng==lang.id)[0].currency_id"

                        :options="currencies"
                        :placeholder="$t('currency')"
                        vertical
                    />
                    <CRow>
                      <CCol col="12">
                        <hr>
                      </CCol>

                      <CCol col="6">
                        <CInput v-model="site_config.titles.filter(x=>x.lng==lang.id)[0].instagram_link"
                                label="لینک اینستاگرام"/>
                      </CCol>

                      <CCol col="6">
                        <CInput v-model="site_config.titles.filter(x=>x.lng==lang.id)[0].telegram_link"
                                label="لینک تلگرم"/>
                      </CCol>
                      <CCol col="12">
                        <CTextarea style="direction: ltr"
                                   v-model="site_config.titles.filter(x=>x.lng==lang.id)[0].footer"
                                   :label="$t('footer_html')"/>
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol col="4">

                    <ImageSelector :label="$t('logo')"
                                   :media_id.sync="logo_file"
                                   default_archive="site"
                                   :preview-image="site_config.logo"
                    />
                  </CCol>
                  <CCol col="4">

                    <ImageSelector :label="$t('browser_icon')"
                                   :media_id.sync="favicon_file"
                                   default_archive="site"
                                   :preview-image="site_config.favicon"
                    />
                  </CCol>
                  <CCol col="4">

                    <ImageSelector :label="$t('cover_image')"
                                   :media_id.sync="cover_file"
                                   default_archive="site"
                                   :preview-image="site_config.cover"
                    />
                  </CCol>


                </CRow>
                <hr>
                <!--                <CRow>-->
                <!--                  <CCol col="3">-->
                <!--                    <CInput label="درصد ارزش افزوده"-->
                <!--                            v-model="vat"-->
                <!--                    />-->

                <!--                  </CCol>-->
                <!--                  <CCol col="3">-->
                <!--                    <CInput-->
                <!--                        style="direction: ltr"-->
                <!--                        label="کد گوگل انالیتیکس"-->
                <!--                        v-model="google_analytics"-->
                <!--                    />-->

                <!--                  </CCol>-->
                <!--                  <CCol col="3">-->
                <!--                    <CSelect-->
                <!--                        label="زمان کش سایت"-->
                <!--                        :options="[{label:'1 ساعت',value:'1'},-->
                <!--        {label:'2 ساعت',value:'2'},-->
                <!--        {label:'4 ساعت',value:'4'},-->
                <!--        {label:'8 ساعت',value:'8'},-->
                <!--        {label:'12 ساعت',value:'12'},-->
                <!--        {label:'24 ساعت',value:'24'},-->
                <!--        {label:'48 ساعت',value:'48'}]"-->
                <!--                        :value.sync="cache_time"-->
                <!--                    />-->

                <!--                  </CCol>-->
                <!--                </CRow>-->

                <CButton @click="update_settings()" size="sm"
                         color="primary">
                  <CIcon name="cil-check-circle"/>
                  {{ $t('update') }}
                </CButton>
              </CTab>
              <CTab :title="$t('template_settings')">
                <CRow>
                  <CCol col="4">
                    <CSelect
                        :options="[{label:$t('select'),value:0},{label:$t('vazir'),value:'vazir'},{label:$t('dastnevis'),value:'dastnevis'}]"
                        :label="$t('font')"
                        :value.sync="design.font"
                    />
                  </CCol>
                  <CCol col="4">
                    <CSelect
                        :options="[{label:$t('select'),value:0},{label:$t('type_one'),value:1},{label:$t('type_two'),value:2},{label:$t('type_three'),value:3}]"
                        :label="$t('header_type')"
                        :value.sync="design.header_type"
                    />
                  </CCol>
                  <CCol col="4">
                    <CSelect
                        :options="[{label:$t('select'),value:-1},{label:$t('type_one'),value:1},{label:$t('type_two'),value:2},{label:$t('type_three'),value:3}]"
                        :label="$t('product_card')"
                        :value.sync="design.card_type"
                    />
                  </CCol>
                  <CCol col="4">
                    <CSelect
                        :options="[{label:$t('select'),value:-1},{label:$t('horizontal'),value:'horizontal_top'},{label:$t('vertical_left'),value:'vertical_left'},{label:$t('vertical_right'),value:'vertical_right'}]"
                        :label="$t('category_menu')"
                        :value.sync="design.menu_type"
                    />
                  </CCol>
                  <CCol col="4">
                    <CInput type="color"
                            :label="$t('background_color')"
                            v-model="design.background_color"
                    />
                  </CCol>
                  <CCol col="4">
                    <CInput type="color"
                            :label="$t('text_color')"
                            v-model="design.text_color"
                    />
                  </CCol>
                  <CCol col="4">
                    <CInput type="color"
                            :label="$t('menu_background_color')"
                            v-model="design.background_menu_color"
                    />
                  </CCol>
                  <CCol col="4">
                    <CInput type="color"
                            :label="$t('menu_text_color')"
                            v-model="design.text_menu_color"
                    />
                  </CCol>
                  <CCol col="4">
                    <CInput type="color"
                            :label="$t('menu_background_active_color')"
                            v-model="design.background_menu_hover_color"
                    />
                  </CCol>

                  <CCol col="4">
                    <CInput type="color"
                            :label="$t('product_card_background_color')"
                            v-model="design.background_card_color"
                    />
                  </CCol>
                  <CCol col="4">
                    <CInput type="color"
                            :label="$t('product_card_title_color')"
                            v-model="design.card_text_color"
                    />
                  </CCol>
                  <CCol col="4">
                    <CInput type="color"
                            :label="$t('color_product_card')"
                            v-model="design.card_price_color"
                    />
                  </CCol>
                  <CCol col="4">
                    <CInput type="color"
                            :label="$t('color_summary_product_card')"
                            v-model="design.card_description_color"
                    />
                  </CCol>



                </CRow>
                <CButton @click="update_design()" size="sm"
                         color="primary">
                  <CIcon name="cil-check-circle"/>
                  {{ $t('save') }}
                </CButton>
              </CTab>

            </CTabs>


          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CCardBody>

    </CCardBody>


  </div>

</template>

<script>
import axios from "axios";


// import the styles

export default {
  name: 'Login',
  components: {},
  data() {

    return {
      design:{},
      payment_type: '',
      payment_time: '',
      payment_deposit_info: '',
      db_url: localStorage.getItem("api_address"),
      site_config: {},
      languages: [],
      vat: "0",
      google_analytics: "",
      cache_time: "",
      currencies: [],
      sms_templates: [],
      logo_file: null,
      logo_previewImage: null,
      favicon_file: null,
      cover_file: null,
      favicon_previewImage: null,
      right_icon: null,
      left_icon: null,
    }
  },
  mounted() {

    this.get_data();

  }, watch: {},
  methods: {

    get_data() {
      var self = this;
      var formData = new FormData();
      axios.post('/api/admin/site/get_config', formData, {}).then(function (response) {
        // console.log("cats is "+response.data.groups);
        // console.log("cats is "+items);

        var content_cats = response.data;
        content_cats.languages.forEach(function (lang) {
          if (content_cats.configs.titles.filter(x => x.lng == lang.id).length == 0) {
            var obj = {}
            Object.assign(obj, content_cats.configs.title)
            obj.lng = lang.id;
            content_cats.configs.titles.push(obj)
          }

        })
        self.site_config = content_cats.configs
        self.currencies = self.sort_array([], content_cats.currencies, "id", "title")
        self.languages = content_cats.languages
        self.sms_templates = content_cats.sms_templates
        self.vat = content_cats.vat
        self.google_analytics = content_cats.google_analytics
        self.cache_time = content_cats.cache_time
        self.payment_type = content_cats.payment_type
        self.payment_time = content_cats.payment_time
        self.payment_deposit_info = content_cats.payment_deposit_info
        try {
          self.design = JSON.parse(content_cats.design.design)
        }catch (e) {
          console.log("error parse design",e)
        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },

    update_settings() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "/api/admin/site/update_config";

      this.site_config.titles[0].right_icon = this.right_icon
      this.site_config.titles[0].left_icon = this.left_icon
      formData.append('site_config', JSON.stringify(this.site_config));
      formData.append('logo_file', this.logo_file);
      formData.append('favicon_file', this.favicon_file);
      formData.append('cover_file', this.cover_file);
      formData.append('vat', this.vat);
      formData.append('left_icon', this.left_icon);
      formData.append('right_icon', this.right_icon);
      formData.append('vat', this.vat);
      formData.append('google_analytics', this.google_analytics);
      formData.append('cache_time', this.cache_time);
      formData.append('payment_type', this.payment_type);
      formData.append('payment_time', this.payment_time);
      formData.append('payment_deposit_info', this.payment_deposit_info);


      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);


      }).catch(function (error) {

        console.log(error);
      });

    },
    update_design() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "/api/admin/site/update_design";


      formData.append('data', JSON.stringify(this.design));


      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);


      }).catch(function (error) {

        console.log(error);
      });

    },
  }
}


</script>
<style>

</style>
